import React, { useEffect, useState } from "react";
import { DashboardShell } from "@/components/DashboardLayout";
import { BackButton } from "@/components/Layout";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { api, fmtSASTDate, fmtZAR } from "@/lib/api";

const STATUS_COLOR = {
  approved: "bg-[#00C853]/10 text-[#00C853] border-[#00C853]/30",
  pending: "bg-orange-50 text-orange-700 border-orange-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
};

export default function AdminMerchants() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/admin/merchants").then(({ data }) => setList(data.merchants || [])); }, []);
  return (
    <DashboardShell role="admin">
      <BackButton to="/admin" />
      <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">Merchants</p>
      <h1 className="font-display mt-2 text-3xl font-bold text-[#0A2540]">All merchants</h1>
      <div className="mt-6 bg-white border border-[#E5E7EB] rounded-2xl overflow-x-auto">
        <Table data-testid="admin-merchants-table">
          <TableHeader>
            <TableRow>
              <TableHead>Created</TableHead>
              <TableHead>Name</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Email / Phone</TableHead>
              <TableHead>KYC</TableHead>
              <TableHead>Wallet</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {list.length === 0 && <TableRow><TableCell colSpan={6} className="text-center py-8 text-[#666666]">No merchants yet</TableCell></TableRow>}
            {list.map((m) => (
              <TableRow key={m.id}>
                <TableCell className="text-xs">{fmtSASTDate(m.created_at)}</TableCell>
                <TableCell>
                  <p className="font-semibold text-[#0A2540]">{m.contact_name || m.user?.full_name}</p>
                  {m.business_name && <p className="text-xs text-[#666666]">{m.business_name}</p>}
                </TableCell>
                <TableCell className="text-xs uppercase">{m.account_type}</TableCell>
                <TableCell className="text-xs">{m.user?.email || m.user?.phone || "—"}</TableCell>
                <TableCell><Badge className={`border ${STATUS_COLOR[m.kyc_status] || ""}`}>{m.kyc_status}</Badge></TableCell>
                <TableCell className="font-mono">{fmtZAR(m.wallet_balance || 0)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </DashboardShell>
  );
}
